interface OnboardingProjectHeaderProps {
  org: string;
  project: string;
  repoName: string;
  branchName: string;
}

const OnboardingProjectHeader = ({
  org,
  project,
  repoName,
  branchName,
}: OnboardingProjectHeaderProps) => (
  <div className="mb-4 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-xl border border-solid border-[var(--inv-border)] bg-[var(--inv-surface-muted)] px-3.5 py-2.5 text-[0.8125rem] text-[var(--inv-text-secondary)]">
    <span>
      <strong className="font-semibold text-[var(--inv-text)]">Organization:</strong>{' '}
      {org || '—'}
    </span>
    <span>
      <strong className="font-semibold text-[var(--inv-text)]">Project:</strong>{' '}
      {project || '—'}
    </span>
    <span>
      <strong className="font-semibold text-[var(--inv-text)]">Repository:</strong>{' '}
      {repoName || '—'}
    </span>
    <span>
      <strong className="font-semibold text-[var(--inv-text)]">Branch:</strong>{' '}
      {branchName || '—'}
    </span>
  </div>
);

export default OnboardingProjectHeader;
